import { Filter, FilterOption, FilterSection } from "@/components/ui/filter";
import { ScrollArea, ScrollBar } from "@/components/ui/scroll-area";
import { Sidebar, SidebarContent, SidebarGroup, SidebarGroupLabel, SidebarProvider, SidebarTrigger } from "@/components/ui/sidebar";
import { useIsMobile } from "@/hooks/use-mobile";
import { useLocation, useParams } from "wouter";

export const AccountLayout: React.FC<React.PropsWithChildren> = ({ children }) => {
  const isMobile = useIsMobile();

  const { tab } = useParams();
  const currentTab = tab || 'profile';

  let sidebarItems = [
    {
      path: 'profile', // this will serve as the path /account/profile
      label: 'Profile', // this is how it's displayed on the nav bar
    },
    {
      path: 'download-musio',
      label: 'Download Musio',
    },
    {
      path: 'musio-plus',
      label: 'Musio+',
    },
    {
      path: 'licenses',
      label: 'Licenses',
    },
  ];

  if (isMobile) {
    sidebarItems = sidebarItems.filter(item => item.path !== 'download-musio');
  }

  return (
    <div className="container flex flex-col gap-8 w-full mx-auto h-full">
      <div className="flex items-center justify-between mb-6 shrink-0">
        <h1 className="text-3xl font-bold text-white">Account</h1>
      </div>
      <SidebarProvider
        className="
          flex-1 min-h-0 gap-4
          grid grid-cols-1 grid-rows-[auto_1fr]
          md:grid-cols-5 md:grid-rows-1
        "
      >
        {isMobile ? (
          <Sidebar>
            <SidebarContent className="musio-glass min-h-0">
              <SidebarGroup>
                <SidebarGroupLabel className="text-xl font-bold">
                  Options
                </SidebarGroupLabel>
                <FilterSidebar currentTab={currentTab} sidebarItems={sidebarItems} />
              </SidebarGroup>
            </SidebarContent>
          </Sidebar>
        ) : (
          <div className="col-span-1 musio-glass min-h-0 overflow-auto">
            <FilterSidebar currentTab={currentTab} sidebarItems={sidebarItems} />
          </div>
        )}

        <SidebarTrigger className="px-7 row-start-1 col-span-full md:hidden" />

        <ScrollArea className="col-span-4 h-full min-h-0 musio-glass">
          <div className="h-full flex flex-col">
            {children}
          </div>
          <ScrollBar orientation="vertical" />
        </ScrollArea>


      </SidebarProvider>
    </div>
  );

}

// simple abstraction of the FilterSidebar present in this componenet only
const FilterSidebar = ({
  currentTab,
  sidebarItems,
}: {
  currentTab: string,
  sidebarItems: { path: string, label: string }[]
}) => {
  const [, navigate] = useLocation();

  return (
    <Filter
      className="px-3 py-3"
      activeOptions={currentTab ? [sidebarItems.find((i) => i.path == currentTab)?.label!] : []}
      multiSelect={false}
    >
      <FilterSection className="overflow-hidden">
        {sidebarItems.map((i, index) =>
          <FilterOption
            className="p-2"
            key={index}
            onPressedChange={() => {
              navigate(`/${i.path}`)
            }}
          >
            {i.label}
          </FilterOption>
        )}
      </FilterSection>
    </Filter>
  );
};
